<template>
	<div class="ak-login-content">
		<section>
			<TheForm></TheForm>
		</section>
	</div>
</template>

<script>
import TheForm from "../components/Login/TheForm.vue";
export default {
    components:{
        TheForm
    },
    data () {
        return {
        };
    },
    created () {
    }
};
</script>

<style lang="less">
	.ak-login-content{
		background:url('../assets/images/background.png') no-repeat;
		background-size:cover;
		height: 100%;
		overflow: auto;
		header{
			height: 60px;
			overflow: hidden;
		}
		section{
			text-align:center;
			width: 100%;
			height: 300px;
			margin: 0 auto;
			padding-top: 90px;
			display: flex;
			display: -webkit-flex;
		}
	}
</style>